import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useLocationContext } from '../../hooks/useLocationContext';
import RetentionScheduleEditor from '../../components/retention/RetentionScheduleEditor';
import RetentionOverview from '../../components/retention/RetentionOverview';

/**
 * Location-scoped admin page for the retention plan (Task 21). LOCATION_ADMIN+
 * only. Composes the editable schedule (with read-only provenance beside each
 * period) and the informational overview. CLOCKS ONLY — nothing on this page
 * deletes any data.
 */
const RetentionSettingsPage: React.FC = () => {
  const { isAdmin } = useAuth();
  const { effectiveLocationId } = useLocationContext();

  if (!isAdmin) {
    return (
      <div className="mx-auto max-w-4xl px-4 py-8">
        <p className="text-sm text-gray-500">You don't have access to manage retention.</p>
      </div>
    );
  }

  if (!effectiveLocationId) {
    return (
      <div className="mx-auto max-w-4xl px-4 py-8">
        <p className="text-sm text-gray-500">Select a location to view its retention plan.</p>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-5xl px-4 py-8" data-testid="retention-settings-page">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Retention plan</h2>
        <p className="mt-1 text-sm text-gray-500">
          Retention clocks only. This screen shows how long records are kept and where each period
          comes from, and counts records past their expiry — it never deletes or anonymises
          anything.
        </p>
      </div>
      <RetentionScheduleEditor locationId={effectiveLocationId} />
      <RetentionOverview locationId={effectiveLocationId} />
    </div>
  );
};

export default RetentionSettingsPage;
